"use strict";

angular.module("core")
.controller("PaymentMethodsCreditCardAccountModalController", function(
    $rootScope, $scope, $q, $timeout, $attrs, $state, close, PaymentMethodsCreditCardService, ReadOnlyPermissionService,
    FlashBag, gettextCatalog, common, Rollbar, PaymentMethodsService, appConfig
) {
    var _this = this;
    $scope.vendorId = $attrs.vendorId;
    $scope.eventCatched = false;
    $scope.ticket = null;
    $scope.showPreAuthorizedMessage = false;
    var supportErrorMessage = gettextCatalog.getString("Moneris Checkout error. Try again or call support.");

    var myCheckout = new monerisCheckout();
    myCheckout.setMode($rootScope.MONERIS_MODE);
    myCheckout.setCheckoutDiv("monerisCheckout");
    myCheckout.setCallback("cancel_transaction", cancelTransaction);
    myCheckout.setCallback("error_event", errorEvent);
    myCheckout.setCallback("payment_complete", checkoutComplete);

    function errorEvent(event) {
        showSupportError(common.parseEvent(event));
    }

    function cancelTransaction(event) {
        _this.close(event);
    }

    function showSupportError(eventData) {
        Rollbar.error(eventData);
        FlashBag.clearAll();
        FlashBag.error(supportErrorMessage);
        _this.close();
    }

    // window.addEventListener only works with static function and $scope.checkoutComplete exists to be unit tested
    function checkoutComplete(event) {
        $scope.checkoutComplete(event);
    }

    $scope.checkoutComplete = function(event) {
        if ($scope.eventCatched) {
            return;
        }

        var eventData = common.parseEvent(event);
        Rollbar.info(eventData);

        if (eventData.response_code === "001" && eventData.ticket) {
            $scope.eventCatched = true;
            PaymentMethodsCreditCardService.receiptCreditCard($scope.vendorId, eventData.ticket)
            .then(function onSuccess(response) {
                FlashBag.clearAll();
                FlashBag.success(gettextCatalog.getString("Credit card account was connected successfully."), true);

                if (appConfig.APP === "customer" && $state.current.name !== "configurePreAuthorizedPayment") {
                    PaymentMethodsService.getPreAuthorizedPaymentMissingCount().then(function onSuccess(response) {
                        if (response.data && (response.data.has_missing_optional || response.data.has_missing_mandatory)) {
                            $scope.showPreAuthorizedMessage = true;
                        }
                        else {
                            _this.close(response);
                        }
                    }, function onError() {
                        _this.close(response);
                    });
                }
                else {
                    _this.close(response);
                }
            }, function onError(response) {
                ReadOnlyPermissionService.handleResponseError(response);
                _this.close(response);
                FlashBag.apiError(response);
            }).finally(function() {
                $scope.eventCatched = false;
            });
        }
        else {
            showSupportError(eventData);
        }
    };

    this.close = function() {
        if ($scope.ticket) {
            myCheckout.closeCheckout($scope.ticket);
        }

        $scope.$element.modal("hide");
        $scope.$element.remove();
        close.apply(this, arguments);
    };

    PaymentMethodsCreditCardService.preloadCreditCard($scope.vendorId)
    .then(function onSuccess(response) {
        $scope.ticket = response.data.ticket;
        myCheckout.startCheckout(response.data.ticket);
    }, function onError(response) {
        _this.close(response);
        FlashBag.apiError(response);
    });

    $scope.configurePreAuthorizedPayment = function() {
        _this.close();
        $state.go("paymentSettings", {tab: 1});
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/payment-methods/modals/payment-methods-credit-card-account.modal.js
// module id = 668
// module chunks = 0